import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class SidebarExpanderService {

  private isSidebarExpanded = new BehaviorSubject<boolean>(false);

  isSidebarExpanded$ = this.isSidebarExpanded.asObservable();

  constructor() { }

  setDynamic(value: boolean) {
    this.isSidebarExpanded.next(value);
  }

}